<template>
  <div class="solution-item">
    <div class="solution-item-pic" :style="'background-image:url('+require('./../assets/images/'+mainSolutionInfo.imgSrc)+')'" />
    <div class="solution-item-title" v-text="mainSolutionInfo.title"/>
    <div style="display: flex;top: 208px;width: 100%; height: 128px;align-items: center;position: absolute;">
      <div class="solution-item-content ellipsis-4" v-text="mainSolutionInfo.desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSolutionItem",
  props:{
    mainSolutionInfo:{
      type:Object,
      default:{
        imgSrc:"",
        title:"",
        desc:"",
      }
    }
  }
};
</script>

<style scoped>

.solution-item {
  width: 380px;
  height: 336px;
  border: 1px solid #00A0E9;
  font-size: 16px;
  line-height: 40px;
  color: #666666;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.solution-item-pic {
  width: 138px;
  height: 138px;
  top: 15px;
  position: absolute;
}

.solution-item-title {
  font-size: 30px;
  color: #00A0E9;
  top: 164px;
  position: absolute;
}

.solution-item-content {
  font-size: 16px;
  color: #666666;
  line-height: 30px;
  box-sizing: border-box;
  padding-left: 26px;
  padding-right: 26px;
  text-align: center;
}

</style>
